import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation } from "../utils/helper";

const SearchLibrary = ({ data, ...props }) => {
  let day, month;

  if (data.datum && data.datum !== "") {
    const parts = data.datum.split("<br>");
    day = parts[0].trim();
    month = parts[1].trim();
  }

  const handleClick = (e, permalink, name, body, address, colour, url) => {
    // Prevent the default link behavior
    e.preventDefault();

    // Set a flag in localStorage (or URL query) to indicate modal toggle
    if (data.type === "routeplanner") {
      localStorage.setItem("showMarkerModal", "true");
      localStorage.setItem("modalDataName", name);
      localStorage.setItem("modalDataBody", body);
      localStorage.setItem("modalDataAdd", address);
      localStorage.setItem("modalDataColour", colour);
      localStorage.setItem("modalDataUrl", url);
    }

    // Redirect to the href (original permalink)
    window.location.href = permalink;
  };

  const link =
    data.type === "contactpersonen"
      ? `/contact?person=${data.title.replace(/\s+/g, "")}`
      : data.permalink;

  return (
    <a
      href={link}
      className={`w-full md:w-[80%] lg:w-[70%] library-card flex items-center gap-4 md:gap-8 hover:opacity-50 ${data.type === "routeplanner" ? "marker-modal-trigger" : ""
        }`}
      onClick={(e) =>
        handleClick(
          e,
          link,
          data.title,
          data.body,
          data.address,
          data.colour,
          data.url
        )
      }
    >
      <div class="w-2/5 lg:w-[25%] relative pb-2 md-pb-0">
        {isArray(data.actueel_type) &&
          data.actueel_type.length > 0 &&
          data.actueel_type.includes("Publicaties") ? (
          <div className="relative aspect-[5/3]">
            {data.imageUrl ? (
              <>
                <div
                  className="w-full aspect-[9/4] rounded-[10px] top-1/2 absolute -translate-y-1/2"
                  style={{ backgroundColor: data.imageColour }}
                ></div>
                <img
                  src={data.imageUrl}
                  alt={data.imageAlt}
                  className="h-full rounded-[10px] ml-[50%] -translate-x-1/2 object-contain"
                />
              </>
            ) : (
              <div className="w-full h-full bg-cirGreyBox rounded-[10px]"></div>
            )}
          </div>
        ) : (
          <div className="w-full h-auto">
            {data.imageUrl ? (
              <img
                src={data.imageUrl}
                alt={data.imageAlt}
                className={`rounded-[10px] w-full aspect-[5/3] ${data.type === "transitieagenda" && data.type === "aan_de_slag"
                  ? "object-contain"
                  : "object-cover"
                  }`}
              />
            ) : null}
          </div>
        )}

        {data.status && data.status.length > 0 && (
          <span class="text-sm scale-text-150:text-lg scale-text-200:text-[22px] absolute top-3 left-3 w-auto mb-4 py-1 px-4 rounded-full border text-white bg-black border-black flex items-center justify-center">
            {data.status}
          </span>
        )}
        {data.datum && data.datum !== "" && (
          <span className="text-center font-sharpgrotesk absolute top-3 left-3 w-auto mb-4 py-1 px-4 rounded-[16px] border text-white bg-black border-black flex flex-col items-center justify-center">
            <span className="text-base scale-text-150:text-2xl scale-text-200:text-3xl">
              {day}
            </span>
            <span className="text-base scale-text-150:text-lg scale-text-200:text-xl">
              {month}
            </span>
          </span>
        )}
      </div>

      <div class="w-3/5 lg:w-[75%]">
        <div class="flex flex-col justify-center">
          {data.type === "transitieagenda" && (
            <p className="text-cirGrey text-sm scale-text-150:text-base scale-text-200:text-lg pb-1 mb-0">
              Transitieagenda
            </p>
          )}
          {data.type === "aan_de_slag" && (
            <p className="text-cirGrey text-sm scale-text-150:text-base scale-text-200:text-lg pb-1 mb-0">
              Aan de slag
            </p>
          )}
          {data.type === "routeplanner" && (
            <p className="text-cirGrey text-sm scale-text-150:text-base scale-text-200:text-lgpb-1 mb-0">
              Circulaire gids 010
            </p>
          )}
          {data.type === "contactpersonen" && (
            <p className="text-cirGrey text-sm scale-text-150:text-base scale-text-200:text-lg pb-1 mb-0">
              Contactpersonen
            </p>
          )}
          {data.type === "agenda" && (
            <div class="location-button text-cirGrey text-sm scale-text-150:text-base scale-text-200:text-lg pb-1 flex items-start gap-4">
              <span class="pt-0.5">{data.location}</span>
            </div>
          )}

          {data.type === "actueel" && (
            <p className="text-cirGrey text-sm scale-text-150:text-base scale-text-200:text-lg pb-1 mb-0">
              {data.date}
            </p>
          )}

          <h3 class="h5 font-normal font-franklin pt-1">{data.title}</h3>

          {data.type === "contactpersonen" && (
            <a
              href={`/contact?person=${data.title.replace(/\s+/g, "")}`}
              className="pt-2 text-cirBlack nav-icon flex gap-2.5 hover:underline hover:underline-offset-4"
            >
              Stuur een bericht
            </a>
          )}

          {data.type === "actueel" && (
            <p className="text-cirGrey text-sm pt-2 mb-0 font-medium">
              {[
                ...(data.transitie || []),
                ...(data.wijken || []), // Default to empty array if undefined
              ]
                .filter(Boolean) // Remove any falsy values
                .map((item, index, array) => (
                  <React.Fragment key={index}>
                    <span>{item}</span>
                    {index !== array.length - 1 && (
                      <span className="px-2">-</span>
                    )}
                  </React.Fragment>
                ))}
            </p>
          )}
        </div>
      </div>
    </a>
  );
};

export default SearchLibrary;
